<!doctype html>
<html lang="en-us">
  <head>
    <meta charset="utf-8" />
    <meta name="description" content="Ember.JS Cheat Sheet" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <!-- VITE_EMBER_SSR_HEAD -->
  </head>
  <body>
    <!-- VITE_EMBER_SSR_BODY -->
    <script type="module" src="/app/entry.ts"></script>
  </body>
</html>
